import { Permission } from './permission';

import { ROLES } from '@data-access';


/** Sampler home map. Not inherited by ADMIN (they use `/ngp-sampling-assignment`). */
const SAMPLER_ONLY_PERMISSIONS = new Set<Permission>([
  Permission.NgpSamplerAssignment,
]);

const ADMIN_PERMISSIONS = Object.values(Permission).filter(
  (permission) => !SAMPLER_ONLY_PERMISSIONS.has(permission),
);

const ROLE_PERMISSIONS: Record<ROLES, ReadonlySet<Permission>> = {
  [ROLES.ADMIN]: new Set(ADMIN_PERMISSIONS),
  [ROLES.DISTRI]: new Set([
    Permission.AccessAdminRoutes,
    Permission.Import,
    Permission.OsLotReviews,
    Permission.SurfacesMap,
    Permission.Users,
    Permission.Accounts,
    Permission.DashboardOwnerFilter,
    Permission.ValidationForms,
    Permission.Results,
  ]),
  [ROLES.INDUSTRIAL]: new Set([
    Permission.AccessAdminRoutes,
    Permission.Contracts,
    Permission.OsLotReviews,
    Permission.SurfacesMap,
    Permission.SamplingPlans,
    Permission.OrganisationSelector,
    Permission.NgpSamplingAssignment,
    Permission.ValidationForms,
    Permission.Results,
  ]),
  [ROLES.USER]: new Set([
    Permission.Import,
    Permission.ValidationForms,
  ]),
  [ROLES.FARMER]: new Set([
    Permission.Import,
    Permission.ValidationForms,
  ]),
  [ROLES.SAMPLER]: new Set([
    Permission.Users,
    Permission.NgpSamplerAssignment,
  ]),
};

export function getRolePermissions(role: ROLES): ReadonlySet<Permission> {
  return ROLE_PERMISSIONS[role];
}
